import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

type PosSelectStyle = {
  selected: boolean
}

export const PosSelectCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1, 1),
  width: '100%',
}))

export const PosSelectItem = styled('p')<PosSelectStyle>(({ selected, theme }) => ({
  fontSize: fontSizes.semiLarge,
  backgroundColor: selected ? colors.yellow : colors.white,
  fontWeight: selected ? 'bold' : 'normal',
  color: selected ? colors.darkBackground : colors.text,
  margin: theme.spacing(0, 1.5),
  cursor: 'pointer',
  borderRadius: 12,
  width: 75,
  height: 30,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.xSmall,
    margin: theme.spacing(0, 1),
    width: '14%',
    height: 30,
  },
}))
